<template>
    <b-modal :active="userActionModal" scroll="keep">
        <div class="modal-card" style="width: auto; max-width:300px; margin: 0 auto;">
            <div class="modal-card-body">
               <div class="has-text-right">
                    <a class=" has-text-danger"
                    @click="emitClose">
                        <b-icon icon="times"></b-icon>
                    </a>
               </div>
                <div class="menu">
                    <ul class="menu-list">
                        <div v-if="!loggedUser">
                            <li>
                                <a :href="loginUrl">
                                    <b-icon class="m-r-5" icon="sign-in-alt"></b-icon>
                                    Entrar
                                </a>
                            </li>
                            <li>
                                <a :href="registerUrl">
                                    <b-icon  class="m-r-5" icon="user-plus"></b-icon> 
                                    Registrarse
                                </a>
                            </li>
                        </div>
                        <div v-else>
                            <li>
                                <a :href="userSettings">
                                    <b-icon class="m-r-5" icon="user-cog"></b-icon> 
                                    Panel de control
                                </a>
                            </li>
                            <li>
                                <a :href="logoutUrl">
                                    <b-icon  class="m-r-5" icon="sign-out-alt"></b-icon> 
                                    Salir
                                </a>
                            </li>
                        </div>
                        
                    </ul>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    props:{
        userActionModal:{
            type:Boolean,
            default:false
        },
        loggedUser:{
            type:Boolean,
            default:false
        },
        logoutUrl:{
            type:String,
            default:""
        },
        loginUrl:{
            type:String,
            default:""
        },
        registerUrl:{
            type:String,
            default:""
        },
        userSettings:{
            type:String, 
            default:""
        },
    },
    methods:{
        emitClose(){
            this.$emit('closeModal')
        }
    }
}
</script>

<style lang="scss" scoped>

.modal-card-body{
    border-radius:10px;
}
</style>

